import { Component, input, output, OutputEmitterRef } from '@angular/core';
import { ApiClientConstant } from '@cureskin/api-client';
@Component({
  selector: 'quiz-banner-v2',
  imports: [],
  templateUrl: './quiz-banner-v2.component.html',
})
export class QuizBannerV2Component {


  userLanguagePreference = input<string>();
  openGame: OutputEmitterRef<boolean> = output();

  handleQuizBannerClick() {
    this.openGame.emit(true);
  }

  getDailyCareTitleClasses(): string {
    const language = this.userLanguagePreference();
    if (language === ApiClientConstant.LanguageString.TE || language === ApiClientConstant.LanguageString.KN) {
      return 'tw-text-700 xs:tw-text-750';
    }
    return 'tw-text-750';
  }

  getQuizTitleClasses(): string {
    const language = this.userLanguagePreference();
    switch (language) {
      case ApiClientConstant.LanguageString.EN:
        return 'tw-text-1200 tw-leading-[48px] -tw-tracking-[3.3px] -tw-mt-2';
      case ApiClientConstant.LanguageString.TE:
      case ApiClientConstant.LanguageString.KN:
        return 'tw-text-800 tw-ml-1';
      default:
        return 'tw-text-1200';
    }
  }
}
